import { render, staticRenderFns } from "./OnboardingChat.vue?vue&type=template&id=2274da60&scoped=true"
import script from "./OnboardingChat.vue?vue&type=script&lang=js"
export * from "./OnboardingChat.vue?vue&type=script&lang=js"
import style0 from "./OnboardingChat.vue?vue&type=style&index=0&id=2274da60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2274da60",
  null
  
)

export default component.exports